export type FacetMode = 'in' | 'nin'

export interface FacetValue {
  values: string[]
  mode: FacetMode
}

export function emptyFacet(): FacetValue {
  return { values: [], mode: 'in' }
}

export function isFacetActive(facet: FacetValue | undefined | null): boolean {
  return !!facet && facet.values.length > 0
}

export function parseFacetMode(raw: unknown): FacetMode {
  return raw === 'nin' ? 'nin' : 'in'
}

export function coerceFacet(raw: unknown): FacetValue {
  if (raw == null || raw === '') return emptyFacet()
  if (typeof raw === 'string') return { values: [raw], mode: 'in' }
  if (Array.isArray(raw)) {
    return { values: raw.filter((v): v is string => typeof v === 'string' && v.length > 0), mode: 'in' }
  }
  if (typeof raw === 'object') {
    const obj = raw as { values?: unknown; mode?: unknown }
    if (Array.isArray(obj.values)) {
      return {
        values: obj.values.filter((v): v is string => typeof v === 'string' && v.length > 0),
        mode: parseFacetMode(obj.mode),
      }
    }
  }
  return emptyFacet()
}

export function facetToQuery(name: string, facet: FacetValue | undefined): Record<string, string[] | string> {
  if (!isFacetActive(facet)) return {}
  const params: Record<string, string[] | string> = { [name]: facet!.values }
  if (facet!.mode === 'nin') params[`${name}_mode`] = 'nin'
  return params
}

export type FacetOption = {
  value: string
  label: string
}
